export default {
    returnEmptyStrIfDataUndefined: function (d) {
        if (typeof d == "undefined" || d == null)
            return "";
        return d;
    },
    returnNaIfDataUndefined: function (d) {
        if (typeof d == "undefined" || d == null)
            return "N/A";
        return d;
    },
    dateTimeStringToDate(str){
        var tempStrs = str.split(" ");
        var dateStrs = tempStrs[0].split("-");
        var year = parseInt(dateStrs[0], 10);
        var month = parseInt(dateStrs[1], 10) - 1;
        var day = parseInt(dateStrs[2], 10);
        var hour = 0;
        var minute = 0;
        var second = 0;
        if(typeof tempStrs[1] !== "undefined" && tempStrs[1]){
            var timeStrs = tempStrs[1].split(":");
            hour = parseInt(timeStrs [0], 10);
            minute = parseInt(timeStrs[1], 10);
            second = parseInt(timeStrs[2], 10);
        }
        return new Date(year, month, day, hour, minute, second);
    },
    getMonthStartAndEndDate: function (curDate) {
        if(!curDate)
            curDate = new Date(); // 获取当前日期
        var _curDate =  new Date(curDate);
        // 获取当前月份最后一天的日期，setDate(0):设置为上个月最后一天
        var last = new Date(_curDate.setMonth(_curDate.getMonth() + 1));
        last = new Date(last.setDate(0));
        var dayNum = last.getDate(); // 获取当前月份的总天数
        var first = new Date(curDate.getFullYear(), curDate.getMonth(), 1); // 获取当前月份第一天的日期
        return [this.DateToDateStr(first), this.DateToDateStr(last), dayNum];
    },
    /**
     * @return {string}
     */
    DateToDateStr(date){
        if(!date)
            date = new Date();
        return date.getFullYear() + "-" + parseInt(date.getMonth()+1, 10) + "-" + parseInt(date.getDate(), 10);
    },
    DateToDateTimeStr(date){
        if(!date)
            date = new Date();
        return date.getFullYear() + "-" + parseInt(date.getMonth()+1, 10) + "-" + parseInt(date.getDate(), 10) + " " + parseInt(date.getHours(), 10) + ":" + parseInt(date.getMinutes(), 10) + ":" + parseInt(date.getSeconds(), 10);
    },

    /**
    * 生成随机码(只含有数字和字母的随机码)
     * randomFlag 是否任意长度 min 任意长度最小位[固定位数] max 任意长度最大位
    */
    randomWord(randomFlag=false, min=6, max=6) {
        let str = "",
            range = min,
            arr = [
                'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
                'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
                'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z','0', '1', '2', '3', '4', '5', '6', '7', '8', '9',];

        if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;// 任意长度
        }
        for (let i = 0; i < range; i++) {
            let pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
        }
        return str;
    },
}



// WEBPACK FOOTER //
// ./src/utils/dataFormat.js